<div class="" [formGroup]="form">

    <div fxLayoutAlign="center flex-start">
        <app-collaborator-chips *ngIf="editable" fxFlex="1 1 auto"
        formControlName="user" permissionAdd="true" permissionRemove="true"
        label="{{'ALERTS.ADD_SELECTED_TEAM' | translate}}"></app-collaborator-chips>

        <button mat-stroked-button color="accent" 
            fxFlex="200px" class="ml-8"
            [matMenuTriggerFor]="permissionMenu" 
            [ngSwitch]="selectedTeamRole" [disabled]="!editable">
            <ng-container *ngSwitchCase="assignedTeamRoles.viewer">
                <mat-icon class="mr-8 pt-4">visibility</mat-icon>
                <span>{{'ALERTS.CAN_VIEW' | translate}}</span>
            </ng-container>
            <ng-container *ngSwitchCase="assignedTeamRoles.responder">
                <mat-icon class="mr-8 pt-4">question_answer</mat-icon>
                <span>{{'ALERTS.CAN_ANSWER' | translate}}</span>
            </ng-container>
            <ng-container *ngSwitchCase="assignedTeamRoles.reviewer">
                <mat-icon class="mr-8 pt-4">edit</mat-icon>
                <span>{{'ALERTS.CAN_REVIEW' | translate}}</span>
            </ng-container>
        </button>

        <mat-menu #permissionMenu="matMenu">
            <button mat-menu-item 
                [disabled]="checkSelectablePermission(assignedTeamRoles.viewer)"
                (click)="selectedTeamRole = assignedTeamRoles.viewer" [disabled]="!editable">
                <mat-icon>visibility</mat-icon>
                <span>{{'ALERTS.CAN_VIEW' | translate}}</span>
            </button>
            <button mat-menu-item 
                [disabled]="checkSelectablePermission(assignedTeamRoles.responder)"
                (click)="selectedTeamRole = assignedTeamRoles.responder" [disabled]="!editable">
                <mat-icon>question_answer</mat-icon>
                <span>{{'ALERTS.CAN_ANSWER' | translate}}</span>
            </button>
            <button mat-menu-item 
                [disabled]="checkSelectablePermission(assignedTeamRoles.reviewer)"
                (click)="selectedTeamRole = assignedTeamRoles.reviewer" [disabled]="!editable">
                <mat-icon>edit</mat-icon>
                <span>{{'ALERTS.CAN_REVIEW' | translate}}</span>
            </button>
        </mat-menu>
    </div>

    <div fxLayoutAlign="flex-end center">
        <button mat-raised-button color="accent" (click)="addMembers()" [disabled]="!editable || !canAddTeam">
            <span>{{'ALERTS.ADD_SELECTED_TEAM' | translate}}</span>
        </button>
    </div>

    <mat-selection-list [multiple]="false">

        <div *ngIf="teamSelected.length" mat-subheader>{{'ALERTS.SELECTED_TEAM' | translate}}</div>
        <div *ngIf="!teamSelected.length" mat-subheader>{{'ALERTS.NO_SELECTED_TEAM' | translate}}</div>

        <div *ngIf="loadingUsers || loadingGroups"
            style="max-height: 30px; position: relative; left: 50%;">
            <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>

        <ng-container *ngIf="!loadingUsers && !loadingGroups">

            <mat-list-item *ngFor="let member of teamSelected">
                <div fxFlex="60" style="display: flex;">
                    <mat-icon matListItemIcon [ngSwitch]="member.type" class="secondary-text mr-8">
                        <ng-container *ngSwitchCase="memberType.User">person</ng-container>
                        <ng-container *ngSwitchCase="memberType.Group">people</ng-container>
                        <ng-container *ngSwitchCase="memberType.Others">account_circle</ng-container>
                    </mat-icon>

                    <div style="display:block">
                        <div mat-line>
                            <strong class="text-truncate" matTooltip="{{ member.description + 
                                ( currentUser.userId == member.id && member.type == memberType.User ? 
                                    ' (' + ('ALERTS.YOU' | translate) + ')' : '' ) }}">
                                {{member.description}}
                                <span *ngIf="currentUser.userId == member.id && member.type == memberType.User">
                                    ({{'ALERTS.YOU' | translate}})</span>
                            </strong>
                        </div>

                        <div mat-line class="secondary-text">
                            <span>{{ 'COLAB-SUGGEST.TYPE.' + (member.type | titlecase) | translate}}</span>
                        </div>
                    </div>
                </div>

                <div fxLayoutAlign="flex-end center" fxFlex="40">

                    <button mat-stroked-button color="accent" 
                        fxFlex="180px" class="ml-8"
                        [matMenuTriggerFor]="menu"
                        [ngSwitch]="checkSelectedPermission(member)" [disabled]="!editable">
                        <ng-container *ngSwitchCase="assignedTeamRoles.viewer">
                            <mat-icon class="mr-8 pt-4">visibility</mat-icon>
                            <span>{{'ALERTS.CAN_VIEW' | translate}}</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="assignedTeamRoles.responder">
                            <mat-icon class="mr-8 pt-4">question_answer</mat-icon>
                            <span>{{'ALERTS.CAN_ANSWER' | translate}}</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="assignedTeamRoles.reviewer">
                            <mat-icon class="mr-8 pt-4">edit</mat-icon>
                            <span>{{'ALERTS.CAN_REVIEW' | translate}}</span>
                        </ng-container>
                    </button>
                </div>

                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngIf="member.canBeViewer" 
                        (click)="updateStakeholderRole(member, assignedTeamRoles.viewer, $event)" [disabled]="!editable">
                        <mat-icon>visibility</mat-icon>
                        <span>{{'ALERTS.CAN_VIEW' | translate}}</span>
                    </button>
                    <button mat-menu-item *ngIf="member.canBeResponder" 
                        (click)="updateStakeholderRole(member, assignedTeamRoles.responder, $event)" [disabled]="!editable">
                        <mat-icon>question_answer</mat-icon>
                        <span>{{'ALERTS.CAN_ANSWER' | translate}}</span>
                    </button>
                    <button mat-menu-item *ngIf="member.canBeReviewer" 
                        (click)="updateStakeholderRole(member, assignedTeamRoles.reviewer, $event)" [disabled]="!editable">
                        <mat-icon>edit</mat-icon>
                        <span>{{'ALERTS.CAN_REVIEW' | translate}}</span>
                    </button>

                    <mat-divider *ngIf="member.canBeViewer || member.canBeResponder || member.canBeReviewer">
                    </mat-divider>

                    <button mat-menu-item (click)="removeStakeholder(member)" [disabled]="!editable">
                        <mat-icon *ngIf="member.type == memberType.User">person_remove</mat-icon>
                        <mat-icon *ngIf="member.type == memberType.Group">group_remove</mat-icon>
                        <span>{{'BUTTONS.REMOVE' | translate}}</span>
                    </button>
                </mat-menu>
            </mat-list-item>

        </ng-container>

    </mat-selection-list>

</div>